(ns frontend.ui.component.lp-portal.report.overview.big-figures.controller
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]))

(defn summary-figures
  [report-data]
  (let [data (get-in report-data [:summary-of-returns])]
    [[(util/->multiple (:gross-multiple data)) "Gross multiple"]
     [(util/->multiple (:return-to-investors-multiple-tvpi data)) "Net multiple"]
     [(util/->percent-1-decimal (:gross-irr data)) "Gross IRR"]
     [(util/->percent-1-decimal (:net-irr data)) "Net IRR"]]))

(defn koke-figures
  [report-data]
  (let [data (get-in report-data [:summary-of-returns])]
    [[(util/->multiple (:return-to-investors-multiple-tvpi data)) "Net multiple"]
     [(util/->percent-1-decimal (:net-irr data)) "Net IRR"]]))

(defn resi-summary-figures
  [report-data]
  (let [data (get-in report-data [:summary-of-returns])]
    [[(util/->int-million (:nav-meur data)) "NAV M€"]
     [(util/->percent-1-decimal (:ltv-on-gav data)) "LTV on GAV"]
     [(util/->percent-1-decimal (:total-return-since-inception data))
      "Return since inception p.a."]]))

(defn stockholm-living-summary-figures
  [report-data]
  (let [data (get-in report-data [:summary-of-returns])]
    [[(util/->int-million (:nav-meur data)) "NAV MSEK"]
     [(util/->percent-1-decimal (:ltv-on-gav data)) "LTV on GAV"]
     [(util/->percent-1-decimal (:total-return-since-inception data))
      "Return since inception p.a."]]))

(defn hotel-summary-figures
  [report-data]
  (let [data (get-in report-data [:summary-of-returns])]
    [[(util/->int-million (:nav-meur data)) "NAV M€"]
     [(util/->percent-1-decimal (:ltv-on-fv data)) "LTV on FV"]
     [(util/->percent-1-decimal (:ltv-on-gav data)) "LTV on GAV"]
     [(util/->percent-1-decimal (:total-return-since-inception data))
      "Return since inception"]]))

